"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderByOrder = void 0;
/**
 * SQL ORDER BY direction enum.
 * Used across backend query builders and API schemas.
 */
var OrderByOrder;
(function (OrderByOrder) {
    OrderByOrder["ASC"] = "ASC";
    OrderByOrder["DESC"] = "DESC";
})(OrderByOrder || (exports.OrderByOrder = OrderByOrder = {}));
